import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import filtersBuilder from '../lib/filtersBuilder'

const buildFilter = (raw) => {
  let result = {}
  result = { ...raw, filters: filtersBuilder(raw.inputs) }
  delete result.inputs
  delete result.config
  return result
}

export const loadData = createAsyncThunk(
  'filters/loadData',
  async (payload, { getState }) => {
    const filters = getState().filters.filters[payload.key]
    const res = await axios.post(payload.endpoint, buildFilter(filters))
    if (res) {
      return { key: payload.key, data: res.data }
    }
  }
)
export const getFilter = createAsyncThunk(
  'filters/getFilter',
  async (payload, { getState }) => {
    const filters = getState().filters.filters[payload.key]
    return buildFilter(filters)
  }
)

export const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    filters: {
      PatientsKey: {},
      EventsKey: {},
      DoctorsKey: {},
      ImagesKey: {},
      ContractsKey: {},
      ContractsActiveKey: {},
      AdministratorsKey: {},
      ExaminationsKey: {},
      PatientsDataKey: {},
      PatientsDataPreviewKey: {},
      PatientsListKey: {},
      PatientEventsKey: {},
      PatientNotesKey: {},
    },
    data: {
      PatientsKey: [],
      EventsKey: [],
      DoctorsKey: [],
      ImagesKey: [],
      ContractsKey: [],
      ContractsActiveKey: [],
      AdministratorsKey: [],
      ExaminationsKey: [],
      PatientsDataKey: [],
      PatientsDataPreviewKey: [],
      PatientsListKey: [],
      PatientEventsKey: [],
      PatientNotesKey: [],
    },
  },
  reducers: {
    loadFilterByKey: (state, action) => {
      Object.assign(
        state.filters[action.payload.key],
        JSON.parse(action.payload.filter)
      )
      console.log(`filters loaded (${action.payload.key})`)
    },
    changeProperty: (state, action) => {
      state.filters[action.payload.key][action.payload.property] =
        action.payload.value
    },
    changeInputs: (state, action) => {
      let copy = JSON.parse(
        JSON.stringify(state.filters[action.payload.key].inputs)
      )
      Object.keys(copy).forEach((key) => {
        copy[key].value = action.payload.values[key]
      })
      state.filters[action.payload.key].inputs = copy
    },
    changeOrder: (state, action) => {
      const key = action.payload.orderKey
      if (state.filters[action.payload.key].order === key) {
        state.filters[action.payload.key].orderType =
          state.filters[action.payload.key].orderType === 'asc' ? 'desc' : 'asc'
      } else {
        state.filters[action.payload.key].order = key
        state.filters[action.payload.key].orderType = 'asc'
      }
    },
    buildInitFilter: (state, action) => {
      const config = action.payload.config
      Object.assign(state.filters[action.payload.key], {
        page: config.page || 1,
        paginate: config.paginate || 10,
        orderType: config.orderType || 'asc',
        order: config.order || 'id',
        inputs: config.inputs || {},
        endpoint: action.payload.endpoint,
        config,
      })
    },
    resetFilter: (state, action) => {
      const config =
        state.filters[action.payload.key] &&
        state.filters[action.payload.key].config
      if (config) {
        Object.assign(state.filters[action.payload.key], {
          page: config.page || 1,
          paginate: config.paginate || 10,
          orderType: config.orderType || 'asc',
          order: config.order || 'id',
          inputs: config.inputs || {},
        })
      }
    },
  },
  extraReducers: {
    [loadData.fulfilled]: (state, action) => {
      state.data[action.payload.key] = action.payload.data
    },
  },
})

export const {
  loadFilterByKey,
  changeFilters,
  buildInitFilter,
  changeProperty,
  changeOrder,
  changeInputs,
  resetFilter,
} = filtersSlice.actions

export default filtersSlice.reducer
